import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import { ABreadCrumb } from '../../components/atoms';
import { MHeroImageSlider } from '../../components/molecules';
import {
	OIndustrialInfographic,
	OIndustrialProjects,
	OIndustrialServices,
	OReferenceSlider,
	OContactBanner,
	OCategoriePreview,
} from '../../components/organisme';

import pageConfig from '../../config/page.config';
import { fetchProjects, fetchReferences } from '../../redux/content/contentActions';
import { changeHead } from '../../redux/head/headActions';

import { routes } from '../../constants';
import * as images from '../../assets/images/images';

const mapStateToProps = state => ({
	projects: state.content.projects.result,
	references: state.content.references,
});

class IndustrialPage extends React.Component {
	componentDidMount() {
		this.props.fetchProjects();
		this.props.fetchReferences();
		this.props.changeHead({
			id: pageConfig.industrial.id,
			title: this.props.intl.formatMessage({ id: pageConfig.industrial.title }),
			description: this.props.intl.formatMessage({ id: pageConfig.industrial.description }),
			showSocialMedia: true,
		});
	}

	render() {
		let project;
		let reference;

		if (this.props.projects && this.props.projects.length) {
			project = <OIndustrialProjects items={this.props.projects.slice(0, 3)} />;
		}

		if (this.props.references && this.props.references.length) {
			reference = (<OReferenceSlider
				items={this.props.references}
				className="t-gap--top-lg t-gap--bottom-xx"
			/>);
		}

		return (
			<section className="household-wrapper">
				<MHeroImageSlider
					items={[
						images.industrieSlider1,
						images.industrieSlider2,
						images.industrieSlider3,
						images.industrieSlider4,
					]}
					className="a-hero-home"
				>
					<a href={routes.externalStore} target="_blank" className="m-hero--cta-store">
						<ABreadCrumb
							currentPage="INDUSTRIAL.CTA_STORE.TITLE"
							className="a-breadcrumb--reverse a-breadcrumb--override-large"
						/>
					</a>
				</MHeroImageSlider>
				<OIndustrialInfographic className="section-xx layout-body household-home-story" />
				<OIndustrialServices />
				{reference}
				{project}
				<div className="section-xx t-gap--top-xl t-gap--bottom-xl">
					<OCategoriePreview items={pageConfig.industrial.productPreviewList} />
				</div>
				<OContactBanner type="industrial" href={`${routes.INDUSTRIAL.CONTACT}`} />
			</section >
		);
	}
}

IndustrialPage.propTypes = {
	changeHead: PropTypes.func.isRequired,
	fetchProjects: PropTypes.func.isRequired,
	fetchReferences: PropTypes.func.isRequired,
};

export default withRouter(connect(mapStateToProps, {
	changeHead,
	fetchProjects,
	fetchReferences,
})(injectIntl(IndustrialPage)));



// WEBPACK FOOTER //
// ./src/pages/industrial/industrial.page.js